export const RecommendationPropertyDefaultDistance = 5000;
